// AutoGenerated
export enum EnmOneriSarkiDurum {
    "Yorum Bekleniyor" = 1,
    "Onaylandı" = 2,
    "Reddedildi" = 3,
    "Güncelleme Bekliyor" = 4,
}